import type { RouteRecordRaw } from 'vue-router';

export const DAILY_SALES_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/daily',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/daily/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/daily/views/List.vue'),
        name: 'Daily Sales List',
        meta: {
          title: '일별 매출조회',
        },
      },
    ],
  },
];
